import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment.development';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class BaseDataService {

  baseUrl: string;
  private token: string="";
  private lang : string="en"

  constructor(
    private http: HttpClient,
    private authService :AuthService
    ){
    this.baseUrl = environment.baseUrl;
    this.lang=localStorage.getItem('lang') ?? 'en'
  }

  makeGetCall(path: string): Observable<any> {
    let headers = new HttpHeaders({'Authorization': 'bearer ' + this.getToken() ,'lang':this.lang,timeZone: this.getTimeZone()});
    return this.http.get(this.constructUrl(path), { headers: headers})
  }

  makePostCall(path: string, body: any): Observable<any> {
    let bodyJson = JSON.stringify(body);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Authorization': 'bearer ' + this.getToken(),'lang':this.lang,timeZone: this.getTimeZone()});
    return this.http.post(this.constructUrl(path), bodyJson, { headers: headers })
  }

  makePostCallImageUpload(path: string, form: any): Observable<any> {
    return this.http.post(this.constructUrl(path), form)
  }

  makePostDownloadCall(path: string, body: any): Observable<any> {
    let bodyJson = JSON.stringify(body);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Authorization': 'bearer ' + this.getToken(),'lang':this.lang ,timeZone: this.getTimeZone()});
    return this.http.post(this.constructUrl(path), bodyJson, { headers: headers , responseType: 'blob'});
  }

  makePostDownloadUploadCall(path: string, body: any): Observable<any> {
    let headers = new HttpHeaders({  'X-Requested-With': 'XMLHttpRequest', 'Authorization': 'bearer ' + this.getToken(),'lang':this.lang ,timeZone: this.getTimeZone()});
    return this.http.post(this.constructUrl(path), body, { headers: headers });
  }

  makeGetDownloadCall(path: string): Observable<any>{
    let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Authorization': 'bearer ' + this.getToken(),'lang':this.lang ,timeZone: this.getTimeZone()});   
    return this.http.get(this.constructUrl(path), {headers: headers, responseType: 'blob'});
  }

  makePostDownloadUploadWithProgressCall(path: string, formData: FormData): Observable<HttpEvent<any>> {
  const headers = new HttpHeaders({
    'X-Requested-With': 'XMLHttpRequest',
    'Authorization': 'bearer ' + this.getToken(),
    'lang': this.lang,
    'timeZone': this.getTimeZone()
  });

  return this.http.post<any>(this.constructUrl(path), formData, {
    headers: headers,
    reportProgress: true,
    observe: 'events'
  });
}


  makePutCall(path: string, body: any): Observable<any> {
    let bodyJson = JSON.stringify(body);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Authorization': 'bearer ' + this.getToken(),'lang':this.lang,timeZone: this.getTimeZone() });
    return this.http.put(this.constructUrl(path), bodyJson, { headers: headers })
  }

  makeDeleteCall(path: string): Observable<any> {
    let headers = new HttpHeaders({'Authorization': 'bearer ' + this.getToken() , 'lang':this.lang,timeZone: this.getTimeZone()});
    return this.http.delete(this.constructUrl(path), { headers: headers})
  }

  makeExternalGetCall(path: string): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json',timeZone: this.getTimeZone()});
    return this.http.get(this.constructUrl(path), { headers: headers })
  }

  makeExternalPostCall(path: string, body: any): Observable<any> {
    let bodyJson = JSON.stringify(body);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json',timeZone: this.getTimeZone()});
    return this.http.post(this.constructUrl(path), bodyJson, { headers: headers })
  }

  private getToken() {
    return this.authService.currentUserValue.token ?? '';
  }

  private constructUrl(path: string) {
    return this.baseUrl + path;
  }

  getTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
